import i from './my-payment.container';

export default i;
